import "./Base.css";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNullOrUndefined, isEmptyString } from "base/utils";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import React, { useEffect, useState } from "react";

const FormTextField = ({
  className,
  defaultValue,
  disabled = false,
  error = false,
  fieldLabel,
  fieldSubText,
  fieldType = "text",
  formClass,
  hasStartAdornment = false,
  id,
  name,
  onBlur,
  onChange,
  onClear,
  placeholder,
  required = false,
  startAdornment,
  tabIndex,
  value,
}) => {
  const [localValue, setLocalValue] = useState(value || defaultValue || "");
  const [isActive, setIsActive] = useState(false);

  const checkPastedValues = (e) => {
    if (fieldType == "number") {
      const pasted = e.clipboardData.getData("text");
      if (/e/i.test(pasted)) {
        e.preventDefault();
      }
    }
  };

  const handleChange = (event) => {
    setLocalValue(event.target.value);
    onChange?.(event.target.value, event);
    setIsActive(true);
  };

  const handleClear = () => {
    setLocalValue("");
    onClear?.();
  };

  const handleBlur = (event) => {
    onBlur?.(event.target.value, event);
    setIsActive(true);
  };

  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  const inputClasses = `${className || ""} Outlined-Input`.trim();

  return (
    <div className={formClass}>
      <FormControl
        className="mb-3"
        fullWidth
        error={
          isActive &&
          (error ||
            (required &&
              (isNullOrUndefined(localValue) || isEmptyString(localValue))))
        }
      >
        <OutlinedInput
          id={id}
          className={inputClasses}
          defaultValue={defaultValue}
          disabled={disabled}
          endAdornment={
            !isNullOrUndefined(localValue) &&
            !isEmptyString(localValue) && (
              <InputAdornment position="end">
                <button type="button" onClick={handleClear}>
                  <FontAwesomeIcon className="fa-thin" icon={faXmark} />
                </button>
              </InputAdornment>
            )
          }
          error={
            isActive &&
            (error ||
              (required &&
                (isNullOrUndefined(localValue) || isEmptyString(localValue))))
          }
          inputProps={{
            onWheel: (e) => e.currentTarget.blur(),
          }}
          label={fieldLabel}
          name={name}
          onBlur={handleBlur}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (fieldType == "number" && ["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onPaste={checkPastedValues}
          placeholder={placeholder}
          required={required}
          startAdornment={
            hasStartAdornment &&
            !isNullOrUndefined(localValue) &&
            !isEmptyString(localValue) && (
              <InputAdornment position="start" disablePointerEvents>
                {startAdornment}
              </InputAdornment>
            )
          }
          tabIndex={tabIndex}
          type={fieldType}
          value={localValue}
        />
        {isActive && fieldSubText && (
          <FormHelperText>{fieldSubText}</FormHelperText>
        )}
        {isActive &&
          isNullOrUndefined(fieldSubText) &&
          required &&
          (isNullOrUndefined(localValue) || isEmptyString(localValue)) && (
            <FormHelperText>Is Required</FormHelperText>
          )}
      </FormControl>
    </div>
  );
};

export default FormTextField;
